<template>
    <PlayerBody v-if="player.uuid" @updateIframeHeight="updateHeight" />
</template>

<script>
import { mapMutations, mapState } from "vuex";
import PlayerBody from "@/views/tools/player/PlayerBody.vue";
import { setFontFamily, updateIframeHeight } from "@/shared/utils";
import { preparePlayer } from "@/shared/projects/prepareData";
import { PREVIEW_ROUTE_NAMES } from "@/views/preview/preview.routes";
import { useAsyncVuexModules } from "@/store/useAsyncVuexModules";
import playerViewModule from "@/views/tools/player/store/player-view.store";
import { projectsService } from "@/shared/projects/projects.service";

export default {
    name: "PlayersPreview",
    components: {
        PlayerBody,
    },
    setup() {
        useAsyncVuexModules(["player/view", playerViewModule]);
    },
    data() {
        return {
            windowWidth: window.innerWidth,
            currentFont: "Inter",
            waiting: false,
        };
    },
    computed: {
        ...mapState("player/view", ["player"]),
    },
    async mounted() {
        if (window.location === window.parent.location) {
            try {
                const player = await this.loadPlayer(this.$route.params.player_uuid);
                this.setPlayer(player);
                await this.adjustIframe();
            } catch {
                this.$router.push({ name: PREVIEW_ROUTE_NAMES.notFound });
            }
        } else {
            window.addEventListener("message", this.handleParentAction);
        }

        window.addEventListener("resize", this.resizeIframe);
    },
    beforeUnmount() {
        window.removeEventListener("message", this.handleParentAction);
        window.removeEventListener("resize", this.resizeIframe);
    },
    methods: {
        ...mapMutations("player/view", ["setPlayer", "setCurrentFile"]),
        async loadPlayer(uuid) {
            this.waiting = true;
            const player = await projectsService.getOne({ tool: "player", uuid });
            this.waiting = false;
            return preparePlayer(player);
        },
        handleParentAction(e) {
            if (e.data?.action === "changeSelectedFile") {
                const id = e.data?.payload?.fileId || 0;
                if (id) {
                    this.setCurrentFile({ file: { id } });
                }
            }
            if (e.data?.action === "playerDataChanged") {
                const player = preparePlayer(e.data.payload || {});
                this.setPlayer(player);
                this.adjustIframe();
            }
        },
        async adjustIframe() {
            this.currentFont = setFontFamily(this.player.fontFamily, this.currentFont);
            await this.$nextTick();
            setTimeout(() => {
                this.updateHeight();
            });
        },
        updateHeight() {
            updateIframeHeight("player", this.player.uuid);
        },
        resizeIframe() {
            if (window.innerWidth !== this.windowWidth) {
                this.adjustIframe();
                this.windowWidth = window.innerWidth;
            }
        },
    },
};
</script>
